
import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControl, FormGroup } from '@angular/forms';
import { RegistrationService } from 'src/main/resources/static/angular2/app/registration/services/registration.service';
import { trigger } from '@angular/animations';
import { smoothEnterLeaveAnimation } from 'src/main/resources/static/angular2/app/shared/animations/custom-animations';
import { PHONE_NUMBER_LIST } from 'src/main/resources/static/angular2/app/shared/constants/phone-numbers.const';
import { DomainNameParserService } from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: [
    './verify-email.component.css',
    './../../../../../assets/css/floating-labels.css'
  ],
  animations: [
    trigger('showEmailLinkSentMessage', smoothEnterLeaveAnimation('100ms', '100ms')),
    trigger('showGenericErrorAlert', smoothEnterLeaveAnimation('100ms', '100ms'))
  ]
})
export class VerifyEmailComponent implements OnInit {

  sendEmailLinkButtonClicked = false;
  emailLinkSent = false;
  genericErrorAlertShown = false;
  customerServicePhone: string;
  
  verifyEmailForm = new FormGroup({
    usernameInput: new FormControl('', [
      Validators.required
    ])
  });

  constructor(private regService: RegistrationService,
              private domainNameParserService: DomainNameParserService) {
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
              }

  ngOnInit(): void {
  }

  sendEmailLink(): void {
    this.sendEmailLinkButtonClicked = true;
    if(!this.verifyEmailForm.valid) {
      return;
    }
    console.log('Sending Verification Email to user: ' + this.verifyEmailForm.controls.usernameInput.value);
    this.emailLinkSent = true;
    this.regService.sendEmailLink(this.verifyEmailForm.controls.usernameInput.value)
      .subscribe(_ => {},
        error => {
          console.error('ServiceLayer returned error. Details: ' + JSON.stringify(error));
          this.emailLinkSent = false;
          this.genericErrorAlertShown = true;
      });
  }

}
